import * as _ from 'lodash'
import {CustomerBO} from "./CustomerBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_CustomerRelationshipRow,
    WB_CustomerDistributionRelationshipRow, WB_CustomerRow,
    WB_CustomerBillToRelationshipRow
} from "../PA.Core/PAdbSchemaRows";
import {PASearch} from "../PA.Core/PASearch";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Customer} from "../PA.Core/PAdbSchema";


export class CustomerBOValidations {

    static async Validation(aBO: CustomerBO): Promise<void> {

            await CustomerBOValidations.ValidateCustomerId(aBO)


            await CustomerBOValidations.ValidateEmptyFields(aBO)


            await CustomerBOValidations.ValidateBillToRelationships(aBO)

    }

    static ValidateEmptyFields(aBO: CustomerBO): Promise<void> {


        return new Promise<void>((resolve, error) => {

            if (_.isEmpty(aBO.WB_Customer.cif.CUSTOMER_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "Customer ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_Customer.cif.CUSTOMER_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyName',
                        type: MessageType.Error,
                        title: "Customer Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyName')
            }

            let bEmptyStartDate = false
            let bEmptyEndDate = false
            let bDateOrderingIncorrect = false
            let bHierarchyIncorrect = false
            _.forEach(_.filter(aBO.WB_Customer.WB_CustomerRelationshipRows_Parents, (x: WB_CustomerRelationshipRow) => x.isActive) , (aRow)=> {

                if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                    bEmptyStartDate = true
                }

                if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                    bEmptyEndDate = true
                }

                if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                    if(aRow.EffectiveEndDt < aRow.EffectiveStartDt){
                        bDateOrderingIncorrect = true
                    }
                }

                if (!aRow.cif.WB_CUSTH_ID) {
                    bHierarchyIncorrect = true
                }
            })

            if(bDateOrderingIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentHierarchyOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Effective start date must be before the effective end date in Parent Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentHierarchyDateOrderingIncorrect')

            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentHierarchyEmptyStartDate',
                        type: MessageType.Error,
                        title: "Effective Start Date cannot be empty in Parent Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentHierarchyEmptyStartDate')
            }

            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentHierarchyEmptyEndDate',
                        type: MessageType.Error,
                        title: "Effective End Date cannot be empty in Parent Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentHierarchyEmptyEndDate')
            }

            if (bHierarchyIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ParentHierarchyEmptyHierarchy',
                        type: MessageType.Error,
                        title: "Hierarchy ID should not be null in Parent Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ParentHierarchyEmptyHierarchy')

            }
            bEmptyStartDate = false
            bEmptyEndDate = false
            bDateOrderingIncorrect = false
            bHierarchyIncorrect = false
            _.forEach(_.filter(aBO.WB_Customer.WB_CustomerRelationshipRows_Children, (x: WB_CustomerRelationshipRow) => x.isActive) , (aRow)=> {

                if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                    bEmptyStartDate = true
                }

                if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                    bEmptyEndDate = true
                }

                if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                    if(aRow.EffectiveEndDt < aRow.EffectiveStartDt){
                        bDateOrderingIncorrect = true
                    }
                }
                if (!aRow.cif.WB_CUSTH_ID) {
                    bHierarchyIncorrect = true
                }
            })

            if(bDateOrderingIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildHierarchyDateOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Effective start date must be before the effective end date in Children Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildHierarchyDateOrderingIncorrect')

            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildHierarchyEmptyStartDate',
                        type: MessageType.Error,
                        title: "Effective Start Date cannot be empty in Children Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildHierarchyEmptyStartDate')
            }
            if (bHierarchyIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildHierarchyEmptyHierarchy',
                        type: MessageType.Error,
                        title: "Hierarchy ID should not be null in Children Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildHierarchyEmptyHierarchy')

            }
            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'ChildHierarchyEmptyEndDate',
                        type: MessageType.Error,
                        title: "Effective End Date cannot be empty in Children Hierarchy",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('ChildHierarchyEmptyEndDate')
            }

            bEmptyStartDate = false
            bEmptyEndDate = false
            bDateOrderingIncorrect = false
            let brelationtype = false

            _.forEach(_.filter(aBO.WB_Customer.WB_CustomerDistributionRelationshipRows, (x: WB_CustomerDistributionRelationshipRow) => x.isActive) , (aRow)=> {

                if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                    bEmptyStartDate = true
                }

                if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                    bEmptyEndDate = true
                }

                if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                    if(aRow.EffectiveEndDt < aRow.EffectiveStartDt){
                        bDateOrderingIncorrect = true
                    }
                }

                if (_.isEmpty(aRow.cif.RELATIONTYPE)) {
                    brelationtype = true
                }
            })

            if(brelationtype){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'relationtype',
                        type: MessageType.Error,
                        title: "Relation Type cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('relationtype')

            }

            if(bDateOrderingIncorrect){
                // Log Message
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'WholesalerDateOrderingIncorrect',
                        type: MessageType.Error,
                        title: "Effective start date must be before the effective end date in Wholesaler",
                        description: "",
                        subtitle: "",
                        count: 0
                    })

            } else {
                aBO.ValidateMessageProvider.removeMessage('WholesalerDateOrderingIncorrect')

            }

            if (bEmptyStartDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'WholesalerEmptyStartDate',
                        type: MessageType.Error,
                        title: "Effective Start Date cannot be empty in Wholesaler",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('WholesalerEmptyStartDate')
            }

            if (bEmptyEndDate) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'WholesalerEmptyEndDate',
                        type: MessageType.Error,
                        title: "Effective End Date cannot be empty in Wholesaler",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('WholesalerEmptyEndDate')
            }

            resolve()

        })

    }

    static ValidateBillToRelationships(aBO: CustomerBO): Promise<void> {

        return new Promise<void>((resolve) => {

            let bEmptyPlanning = false
            let bEmptyBillTo = false

            _.forEach(_.filter(aBO.WB_Customer.WB_CustomerBillToRelationshipRows, (x: WB_CustomerBillToRelationshipRow) => x.isActive), (aRow) => {

                if (!(aRow.cif.WB_CUST_ID_PLANNING > 0)) {
                    bEmptyPlanning = true
                }

                if (_.isEmpty(aRow.cif.BILL_TO_ID)) {
                    bEmptyBillTo = true
                }
            })

            if (bEmptyPlanning) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'BillToRelationshipEmptyPlanning',
                        type: MessageType.Error,
                        title: "Planning Customer must be set in Bill To Relationship",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('BillToRelationshipEmptyPlanning')
            }

            if (bEmptyBillTo) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'BillToRelationshipEmptyBillTo',
                        type: MessageType.Error,
                        title: "Bill To cannot be empty in Bill To Relationship",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('BillToRelationshipEmptyBillTo')
            }

            resolve()

        })

    }

    static async ValidateCustomerId(aBO: CustomerBO): Promise<void> {


        let dbContext = new PAdbContext({})

        let customerRows: WB_CustomerRow[] = await dbContext.findAll(esWB_Customer,
            {where: {DELETED_IND: {neq: '1'},
                           WB_CUST_ID : {neq: aBO.drWB_Customer.cif.WB_CUST_ID},
                           CUSTOMER_ID: aBO.drWB_Customer.cif.CUSTOMER_ID,
                           CUSTOMER_SET_ID:  aBO.drWB_Customer.cif.CUSTOMER_SET_ID,
                           WB_MDSET_ID: aBO.drWB_Customer.cif.WB_MDSET_ID,
                }})
        if (customerRows.length)
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'customeralreadyexits',
                    type: MessageType.Error,
                    title: "Customer Already Exits",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        else
            aBO.ValidateMessageProvider.removeMessage('customeralreadyexits')

    }

}
